<template>
  <section class="d-flex flex-column h-100">
    <fixed-header
      title="Work Orders"
      :records="pageInfo.totalItems"
      hideBackBtn hideNewOfferBtn
    >
      <add-service-order v-if="checkClaim(CAN_ADD_WORK_ORDER)" />
    </fixed-header>

    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-start align-items-end mb-2">
					<b-form-group label="Status" class="mr-2">
						<b-form-select v-model="filterObj.statusId" @change="onSearch">
							<option :value="null">All</option>
							<option v-for="option in sortSelect(serviceOrdersStatusOptions)" :key="option.name" :value="option.id">
								{{option.name}}</option>
						</b-form-select>
					</b-form-group>
					<b-form-group label="Sales Order Number" class="mr-2">
						<b-form-input v-model="filterObj.soNumber" @input="onSearch"  size="sm" />
					</b-form-group>
          <b-form-group label="Purchase Order Number" class="mr-2">
						<b-form-input v-model="filterObj.poNumber" @input="onSearch"  size="sm" />
					</b-form-group>
					<b-form-group label="Company" class="mr-2">
						<b-form-input v-model="filterObj.companyName" @input="onSearch" size="sm" />
					</b-form-group>
          <b-form-group label="Needs auth" class="mr-2" style="margin-bottom: 5px;">
						<b-form-checkbox v-model="filterObj.needsAuthorization" :indeterminate.sync="filterObj.needsAuthorization == null" @input="onSearch" />
					</b-form-group>
					<b-form-group label="Sales Rep" class="mr-2">
						<b-form-select v-model="filterObj.salesPersonUserId" @change="onSearch">
							<option :value="null">All</option>
							<option
								v-for="(selectRep, indexRep) in sortSelect(salesReps)"
								:key="indexRep"
								:value="selectRep.id"
							>{{ selectRep.name }}</option>
						</b-form-select>
					</b-form-group>
          <date-range-picker :dateFrom="filterObj.dateFrom" :dateTo="filterObj.dateTo" @handleSearch="onSearch"></date-range-picker>
					<b-button class="mr-2" size="sm" @click="onClear">Clear filters</b-button>
				</div>
        <grid-component
          isResizable
          isReorderable
          isSortable
          :canEdit="checkClaim(CAN_EDIT_WORK_ORDER)"
          :canDelete="checkClaim(CAN_DELETE_WORK_ORDERS)"
          :gridId="gridId"
          :pageable="pageable"
          :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
          :take="pageInfo.pageSize"
          :itemData="itemData"
          :pageSizes="pageInfo.pageSize"
          :totalItems="pageInfo.totalItems"
          :fields="fields"
          :sortBy="pageInfo.sortBy"
          :sortOrder="pageInfo.sortOrder"
          :sortMethod="sortGrid"
          :onEdit="pushToDetails"
          :onDelete="onDelete"
          :handleRowClick="onRowClick"
          :styleCustom="'height: 335px'"
          @getData="onGetData"
          :isTblLoader="tblLoader"
        />
      </div>
    </div>
    <b-card>
      <b-tabs>
        <b-tab active>
          <template v-slot:title>
            Work Order Items &nbsp;<b-badge variant="primary">{{ serviceOrderLines.length }}</b-badge>
          </template>
          <service-order-lines :serviceOrderId="selectedRowItemId" :checkRowItemIds.sync="checkedRowItemIds" />
        </b-tab>
      </b-tabs>
    </b-card>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';
import { GRID_PAGE_SIZES, GRID_ID } from '@/shared/constants';

import AddServiceOrder from './components/add';
import ServiceOrderLines from './components/ServiceOrderLines';

import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import gridFields from './fields';
import GridComponent from '@/shared/components/GridComponent';
import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';
const SEARCH_DEBOUNCE_TIME = 750;

export default {
  components: {
    ServiceOrderLines,
    FixedHeader,
    AddServiceOrder,
    GridComponent,
    DateRangePicker
  },
  metaInfo: () => ({
    title: 'Work Orders',
  }),
  data() {
    return {
      fields: gridFields,
      gridId: GRID_ID.SERVICE_ORDERS,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0,
      checkedRowItemIds: [],
      serviceOrdersStatusOptions:[
					{ id: 316, name: 'Pending' },
          { id: 317, name: 'Open' },
          { id: 318, name: 'Closed' },
				],
      filterPageName:this.filterPageName
    };
  },
  computed: {
    /*...mapState('serviceOrders', ['lastOpenedId']),*/
    ...mapState('salesReps', ['salesReps']),
    ...mapGetters('serviceOrders', [
      'serviceordersList',
      'pageInfo',
      'filters',
      'lastOpenedId',
      'tblLoader'
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('serviceOrderLines', ['serviceOrderLines']),
    /*serviceOrderLines() {
      return this.serviceOrderLinesById(this.selectedRowItemId);
    },*/
    itemData() {
      if(this.serviceordersList == undefined || this.serviceordersList.length === 0) return [];
      return this.serviceordersList.map((serviceOrder) => ({
        ...serviceOrder,
        selected: serviceOrder.id === this.selectedRowItemId,
      }));
    },
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    filterObj() {
      return this.filters[this.filterPageName] || {}
    }
  },
  methods: {
    ...mapMutations('serviceOrders', [ 'setLastOpenedId', 'setItem' ]),
    ...mapActions('serviceOrders', [
      'getAll',
      'sortGrid',
      'search',
      'clearFilters',
      'deleteServiceOrder',
    ]),
    ...mapActions('account', ['saveGridSettings']),
    ...mapActions('salesReps', ['getSalesReps']),
    async onGetData(params) {
      await this.getAll(params);
    },
    onSearch: debounce(function (data = false) {
      if(typeof data === 'object') { Object.assign(this.filterObj,data) }
      this.selectedRowItemId = 0;
      this.search({'filters':this.filterObj,page:this.filterPageName});
    }, SEARCH_DEBOUNCE_TIME),
    onClear(callSearch=true) {
      // Object.keys(this.filterObj).forEach(filterName => {
      //   this.filterObj[filterName] = null;
      // });
      //
      // this.$refs.dateRangePicker.setDateRangeAll(); //Clear date range picker
      this.clearObject(this.filterObj);
      if(callSearch){this.search({'filters':this.filterObj,page:this.filterPageName});}
    },
    onRowClick(row) {
      if(this.selectedRowItemId != row.dataItem.id){
        this.selectedRowItemId = row.dataItem.id;
      }
    },
    pushToDetails(row) {
      /*this.setLastOpenedId(row.id);*/
      this.setItem({ resource: 'lastOpenedId', payload: row.id });

      this.$router.push({
        name: 'serviceorders.edit',
        params: { id: row.id },
      });
    },
    async onDelete(serviceOrder) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete Work Order #${serviceOrder.id}?`});
      if (deleteConfirmed) {
        await this.deleteServiceOrder(serviceOrder.id);
        this.getAll({});
      }
    },
  },
  watch: {
    async serviceordersList() {
      this.selectedRowItemId = await this.setSelectedRowId(this.serviceordersList,this.selectedRowItemId,this.lastOpenedId);
    }
  },
  async mounted() {
    this.setItem({ resource:'filterPage', payload: this.filterPageName });
    if('clear' in this.$route.query) {
      this.pageInfo.pageNumber = 1;
      this.onClear(false);
      this.clearRoute();
    }else{

      if('needsAuthorization' in this.$route.params && this.$route.params.needsAuthorization) {
        this.filterObj.needsAuthorization = true;
        delete this.$route.params.needsAuthorization;
      }

      if(this.lastOpenedId) {
        this.selectedRowItemId = this.lastOpenedId;
      }
      this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
      await this.getAll({});
      this.getSalesReps();
    }
  },

};
</script>
